import { getData } from '@/views/arki/services/arki-service';
export const objetsList = [{ id: 1, name: 'НС' }, { id: 2, name: 'ТПиР' }]

export const workOwnerList = [{ id: 0, name: 'ЛЭ' }, { id: 1, name: 'Заявитель' }]

export const getObjectTypes = async () => {
    return await getData('/character/object-types', 'f61fc82f-e662-4bca-a556-34a0a60aa39a', null, 'objectTypes');
}

export const getCharacters = async () => {
    return await getData('/characters', 'f5aa9913-be98-47ba-891a-4a39f97d641c', null, 'characters');
}

export const getCharacterList = async (objectTypeId) => {
    return await getData('/character/list/values', '6b2d9e74-249b-48a2-b93d-ba91583daa8c', { objectTypeId }, `characters${objectTypeId}`);
}

export const getWorkSettings = async (objectTypeId) => {
    return await getData('/character/work/settings', '7a1fd421-0db6-4c16-a552-84bfeae20a06', { objectTypeId });
}

export const getWorksList = async () => {
    return await getData('/character/work/list', '3ca055df-75d1-4af6-883a-058db67353a6', null, 'kindWorksList');
}

export const getStagesTechnicalTask = async () => {
    return await getData('/character/stage/technical', 'ddb4285d-6782-4340-8a43-c729dadce834', null, 'stagesTechnicalTask');
}

